import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref, watch } from 'vue';
import ChartHeader from '@/modules/Statistics/components/ChartHeader.vue';
import NewsAddNew from '@/modules/Statistics/CMS/components/NewsAddNew.vue';
import News from '@/modules/Statistics/CMS/api/models/News';
import NewsRepository from '@/modules/Statistics/CMS/api/repositories/NewsRepository';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import moment from 'moment';
import { NewsReport } from '@/interfaces/components/news/NewsReport';
import { DashboardNewsColumn } from '@/interfaces/components/news/DashboardNewsColumn';

interface Props {
    isEdit: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'News',
  props: {
    isEdit: { type: Boolean }
  },
  setup(__props: any) {



const { proxy } = getCurrentInstance()!;

const activeNewsId = ref<string | null>(null);
const isArchivedFilterOn = ref<boolean>(false);
const isNewsModalVisible = ref<boolean>(false);
const loadingOverlay = new LoadingOverlayHelper(proxy as any, {});
const cellPaddingClass = ref<string>('cell-padding--large');

const columns = [
    { title: proxy?.$t('Title'), dataIndex: 'title', key: 'title', class: cellPaddingClass.value },
    { title: proxy?.$t('Date created'), dataIndex: 'createdAt', key: 'createdAt', class: cellPaddingClass.value },
];

const currentLocale = computed(() => {
    if ((proxy as any).$i18n == null) {
        return 'sl';
    }
    return (proxy as any).$i18n.locale;
});

const activeNews = computed<DashboardNewsColumn[]>(() => {
    const reports = NewsRepository.getAll() as NewsReport[];
    if (!reports) {
        return [];
    }

    return reports
        .map((report: NewsReport) => {
            return {
                key: report.id,
                title: report.title,
                createdAt: moment(report.createdAt).format('DD.MM.YYYY'),
                locale: report?.locale?.code ?? currentLocale.value,
            };
        })
        .filter((report) => report.locale === currentLocale.value);
});

function openPopup() {
    isNewsModalVisible.value = true;
}

function closePopup() {
    isNewsModalVisible.value = false;
}

function openNewsReport(reportId: string) {
    activeNewsId.value = reportId;
    openPopup();
}

async function fetchAllNewsReports() {
    loadingOverlay.start();

    try {
        await News.getAll();
    } catch (e) {
        Promise.reject(e);
    } finally {
        loadingOverlay.stop();
    }

    return Promise.resolve();
}

async function fetchArchivedNewsReports() {
    loadingOverlay.start();

    try {
        await News.getAllArchived();
    } catch (e) {
        Promise.reject(e);
    } finally {
        loadingOverlay.stop();
    }

    return Promise.resolve();
}

watch(isArchivedFilterOn, () => {
    if (isArchivedFilterOn.value) {
        fetchArchivedNewsReports();
    } else {
        fetchAllNewsReports();
    }
});

return { __sfc: true,proxy, activeNewsId, isArchivedFilterOn, isNewsModalVisible, loadingOverlay, cellPaddingClass, columns, currentLocale, activeNews, openPopup, closePopup, openNewsReport, fetchAllNewsReports, fetchArchivedNewsReports, ChartHeader, NewsAddNew }
}

})